import { render } from "./ParcoursSpirituels.vue?vue&type=template&id=18e32e87&scoped=true&ts=true"
import script from "./ParcoursSpirituels.vue?vue&type=script&lang=ts"
export * from "./ParcoursSpirituels.vue?vue&type=script&lang=ts"

import "./ParcoursSpirituels.vue?vue&type=style&index=0&id=18e32e87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e32e87"]])

export default __exports__